import dayjs from 'dayjs';
import { array, object, string } from 'yup';

export const incomeValidations = object().shape({
  detail: string(),
  incomeSource: string(),
  frequency: string(),
  amount: string().nullable(),
  startDate: string(),
  endDate: string(),
  isTaxable: string(),
  taxAmount: string().nullable(),
});

export const incomeValidationSchema = object().shape({
  client: array().of(incomeValidations),
  partner: array().of(incomeValidations),
  joint: array().of(incomeValidations),
});

export const incomeDefault = (ffConfig) => {
  return [
    {
      detail: 'Salary',
      incomeSource: '',
      frequency: '',
      amount: 0,
      startDate: '',
      endDate: '',
      isTaxable: '',
      taxAmount: 0,
      show: ffConfig?.salaryIncome?.active ?? true,
    },
    {
      detail: 'Bonus',
      incomeSource: '',
      frequency: '',
      amount: 0,
      startDate: '',
      endDate: '',
      isTaxable: '',
      taxAmount: 0,
      show: true,
    },
    {
      detail: 'Dividends',
      incomeSource: '',
      frequency: '',
      amount: 0,
      startDate: '',
      endDate: '',
      isTaxable: '',
      taxAmount: 0,
      show: ffConfig?.dividendIncome?.active ?? true,
    },
    {
      detail: 'Commisions',
      incomeSource: '',
      frequency: '',
      amount: 0,
      startDate: '',
      endDate: '',
      isTaxable: '',
      taxAmount: 0,
      show: ffConfig?.commissionIncome?.active ?? true,
    },
    {
      detail: 'Pension Income',
      incomeSource: '',
      frequency: '',
      amount: 0,
      startDate: '',
      endDate: '',
      isTaxable: '',
      taxAmount: 0,
      show: ffConfig?.pensionIncome?.active ?? true,
    },
    {
      detail: 'Rental Income',
      incomeSource: '',
      frequency: '',
      amount: 0,
      startDate: '',
      endDate: '',
      isTaxable: '',
      taxAmount: 0,
      show: ffConfig?.rentalIncome?.active ?? true,
    },
    {
      detail: 'Investment Income',
      incomeSource: '',
      frequency: '',
      amount: 0,
      startDate: '',
      endDate: '',
      isTaxable: '',
      taxAmount: 0,
      show: ffConfig?.investmentIncome?.active ?? true,
    },
  ];
};

export const incomeDefaultValues = (ffConfig) => {
  return { client: incomeDefault(ffConfig), partner: incomeDefault(ffConfig), joint: incomeDefault(ffConfig) };
};

export const createIncomePayload = (values: any): any => {
  const mapIncome = (income: any) => {
    const result = income.map((incomeItem: any) => {
      return {
        id: incomeItem.id ?? '',
        incomeSource: incomeItem.incomeSource || '',
        incomeType: incomeItem.detail || '',
        frequency: incomeItem.frequency,
        currency: 'GBP',
        amount: incomeItem.amount || 0,
        startDate: dayjs(incomeItem.startDate).isValid() ? dayjs(incomeItem.startDate).format('YYYY-MM-DD') : '',
        endDate: dayjs(incomeItem.endDate).isValid() ? dayjs(incomeItem.endDate).format('YYYY-MM-DD') : '',
        taxable: incomeItem?.isTaxable?.toLowerCase() === 'yes' ? true : false,
        notes: '',
        taxWithheld: incomeItem.taxAmount ? incomeItem.taxAmount : 0,
        incomeStatementDoc: '',
        incomeStatementDocLocation: '',
      };
    });

    return result;
  };

  return { clientIncome: mapIncome(values.client), partnerIncome: mapIncome(values.partner), jointIncome: mapIncome(values.joint) };
};

export const showField = (ffConfig: any, type: string | undefined) => {
  if (!type) return true;

  const fieldMapping = {
    salary: 'salaryIncome',
    bonus: 'bonusIncome',
    commision: 'commissionIncome',
    dividend: 'dividendIncome',
    pension: 'pensionIncome',
    rental: 'rentalIncome',
    investment: 'investmentIncome',
  };

  for (const [key, value] of Object.entries(fieldMapping)) {
    if (type.includes(key)) {
      return ffConfig?.fields?.[value]?.active ?? true;
    }
  }

  return true;
};
